import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { mediaCreatorApiRef } from './apis/MediaCreatorApi';
import { MediaCreatorClient } from './apis/MediaCreatorClient';

export const mediaCreatorPlugin = createPlugin({
  id: 'media-creator',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: mediaCreatorApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new MediaCreatorClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const MediaCreatorPage = mediaCreatorPlugin.provide(
  createRoutableExtension({
    name: 'MediaCreatorPage',
    component: () =>
      import('./components/MainComponent').then(m => m.MediaCreatorIndex),
    mountPoint: rootRouteRef,
  }),
);
